import { render } from "./DoctorListView.vue?vue&type=template&id=75140c70&ts=true"
import script from "./DoctorListView.vue?vue&type=script&lang=ts"
export * from "./DoctorListView.vue?vue&type=script&lang=ts"

import "./DoctorListView.vue?vue&type=style&index=0&id=75140c70&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__